@if (initializing) {
  <i
    class="bwi bwi-spinner bwi-spin bwi-2x tw-text-muted"
    title="{{ 'loading' | i18n }}"
    aria-hidden="true"
  ></i>
  <span class="tw-sr-only">{{ "loading" | i18n }}</span>
} @else {
  <auth-input-password
    [flow]="inputPasswordFlow"
    [email]="email"
    [userId]="userId"
    [loading]="submitting"
    [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
    [inlineButtons]="true"
    [primaryButtonText]="{ key: 'changeMasterPassword' }"
    (onPasswordFormSubmit)="handlePasswordFormSubmit($event)"
  >
  </auth-input-password>
}
